/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { AdminGetUserPointHistoryInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { AdminGetUserPointHistoryOkDto } from '../../src/model';
// @ts-ignore
import type { JwtAdminAccessGuardUnauthorizedDto } from '../../src/model';
/**
 * AdminPointApi - axios parameter creator
 * @export
 */
export const AdminPointApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 어드민 유저 포인트 내역 조회
         * @param {string} id 아이디
         * @param {AdminPointControllerGetUserPointHistoryPointFilterTypeEnum} [pointFilterType] 
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPointControllerGetUserPointHistory: async (id: string, pointFilterType?: AdminPointControllerGetUserPointHistoryPointFilterTypeEnum, page?: number, limit?: number, startDate?: string, endDate?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPointControllerGetUserPointHistory', 'id', id)
            const localVarPath = `/admin/point/user-history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication accessToken required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (pointFilterType !== undefined) {
                localVarQueryParameter['pointFilterType'] = pointFilterType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate as any instanceof Date) ?
                    (startDate as any).toISOString() :
                    startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate as any instanceof Date) ?
                    (endDate as any).toISOString() :
                    endDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminPointApi - functional programming interface
 * @export
 */
export const AdminPointApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminPointApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 어드민 유저 포인트 내역 조회
         * @param {string} id 아이디
         * @param {AdminPointControllerGetUserPointHistoryPointFilterTypeEnum} [pointFilterType] 
         * @param {number} [page] 현재 페이지
         * @param {number} [limit] 한 페이지에 보여줄 데이터 수
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminPointControllerGetUserPointHistory(id: string, pointFilterType?: AdminPointControllerGetUserPointHistoryPointFilterTypeEnum, page?: number, limit?: number, startDate?: string, endDate?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGetUserPointHistoryOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminPointControllerGetUserPointHistory(id, pointFilterType, page, limit, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminPointApi.adminPointControllerGetUserPointHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminPointApi - factory interface
 * @export
 */
export const AdminPointApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminPointApiFp(configuration)
    return {
        /**
         * 
         * @summary 어드민 유저 포인트 내역 조회
         * @param {AdminPointApiAdminPointControllerGetUserPointHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPointControllerGetUserPointHistory(requestParameters: AdminPointApiAdminPointControllerGetUserPointHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminGetUserPointHistoryOkDto> {
            return localVarFp.adminPointControllerGetUserPointHistory(requestParameters.id, requestParameters.pointFilterType, requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminPointControllerGetUserPointHistory operation in AdminPointApi.
 * @export
 * @interface AdminPointApiAdminPointControllerGetUserPointHistoryRequest
 */
export interface AdminPointApiAdminPointControllerGetUserPointHistoryRequest {
    /**
     * 아이디
     * @type {string}
     * @memberof AdminPointApiAdminPointControllerGetUserPointHistory
     */
    readonly id: string

    /**
     * 
     * @type {'earned' | 'deducted'}
     * @memberof AdminPointApiAdminPointControllerGetUserPointHistory
     */
    readonly pointFilterType?: AdminPointControllerGetUserPointHistoryPointFilterTypeEnum

    /**
     * 현재 페이지
     * @type {number}
     * @memberof AdminPointApiAdminPointControllerGetUserPointHistory
     */
    readonly page?: number

    /**
     * 한 페이지에 보여줄 데이터 수
     * @type {number}
     * @memberof AdminPointApiAdminPointControllerGetUserPointHistory
     */
    readonly limit?: number

    /**
     * 
     * @type {string}
     * @memberof AdminPointApiAdminPointControllerGetUserPointHistory
     */
    readonly startDate?: string

    /**
     * 
     * @type {string}
     * @memberof AdminPointApiAdminPointControllerGetUserPointHistory
     */
    readonly endDate?: string
}

/**
 * AdminPointApi - object-oriented interface
 * @export
 * @class AdminPointApi
 * @extends {BaseAPI}
 */
export class AdminPointApi extends BaseAPI {
    /**
     * 
     * @summary 어드민 유저 포인트 내역 조회
     * @param {AdminPointApiAdminPointControllerGetUserPointHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPointApi
     */
    public adminPointControllerGetUserPointHistory(requestParameters: AdminPointApiAdminPointControllerGetUserPointHistoryRequest, options?: RawAxiosRequestConfig) {
        return AdminPointApiFp(this.configuration).adminPointControllerGetUserPointHistory(requestParameters.id, requestParameters.pointFilterType, requestParameters.page, requestParameters.limit, requestParameters.startDate, requestParameters.endDate, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const AdminPointControllerGetUserPointHistoryPointFilterTypeEnum = {
    Earned: 'earned',
    Deducted: 'deducted'
} as const;
export type AdminPointControllerGetUserPointHistoryPointFilterTypeEnum = typeof AdminPointControllerGetUserPointHistoryPointFilterTypeEnum[keyof typeof AdminPointControllerGetUserPointHistoryPointFilterTypeEnum];
